import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import OnPageEditing from 'components/OnPageEditing';
import cn from 'classnames';
import css from './BusinessAreaBlock.module.scss';
import LinkButton from '../Models/LinkButton/LinkButton';

class BusinessAreaBlock extends React.Component {
    static propTypes = {
        heading: PropTypes.string.isRequired,
        intro: PropTypes.string,
        links: PropTypes.arrayOf(PropTypes.shape(
            Object.assign({}, LinkButton.propTypes, {
                icon: PropTypes.string,
            })        
        )).isRequired,
    };
    
    constructor(props) {
        super(props);
        this.state = {
            currentArea: this.props.links[0].title,
            currentIndex: 0,
            topSrc: false,
            bottomSrc: false,
            bottomOpacity: 0,
            isDesktop: false
        };
    }

    render() {
        const {
            heading,
            intro,
            links,
        } = this.props;
       
        return (
            <div className={css.block}>
                <div className={css.inner}>
                    <OnPageEditing property="Heading">
                        {heading && <h2 className={css.heading}>{heading}</h2>}
                    </OnPageEditing>

                    <OnPageEditing property="Intro">
                        {intro && <div className={css.intro}>{intro}</div>}
                    </OnPageEditing>

                    <OnPageEditing property="BusinessAreas">
                        {links  && (
                            <ul className={css.links}>
                                {links.map((link) => (
                                    <li className={css['links-item']} key={link.text.toString()}>
                                        <a href={link.url} className={cn(css.link)}>
                                            {link.icon && <Icon className={css['link-icon']} icon={link.icon} />}
                                            <span className={css['link-text']}>{link.text}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </OnPageEditing>
                </div>
            </div>
        );
    }
}

export default BusinessAreaBlock;



// WEBPACK FOOTER //
// ./src/components/BusinessAreaBlock/BusinessAreaBlock.jsx